(function() {
  'use strict';

  function initFAQSidebar() {
    const sidebars = document.querySelectorAll('[data-faq-sidebar]');
    
    if (sidebars.length === 0) {
      return;
    }
    
    sidebars.forEach(sidebar => {
      // Skip if already initialized AND elements are found
      if (sidebar.dataset.initialized === 'true') {
        const existingToggles = sidebar.querySelectorAll('[data-category-toggle]');
        if (existingToggles.length > 0) {
          // Check if listeners are attached
          let allHaveListeners = true;
          existingToggles.forEach(t => {
            if (t.dataset.listenerAttached !== 'true') {
              allHaveListeners = false;
            }
          });
          if (allHaveListeners) {
            return; // Already fully initialized
          }
        }
        // If we get here, elements exist but listeners aren't attached, so re-initialize
        sidebar.dataset.initialized = 'false';
      }
      
      const categoryToggles = sidebar.querySelectorAll('[data-category-toggle]');
      
      if (categoryToggles.length === 0) {
        // Don't mark as initialized if no toggles found - allow retry
        return;
      }
      
      categoryToggles.forEach(toggle => {
        // Check if already has listener (prevent duplicates)
        if (toggle.dataset.listenerAttached === 'true') {
          return;
        }
        
        const hasSubcategories = toggle.getAttribute('data-has-subcategories') === 'true';
        
        // Add click handler for accordion toggle
        if (hasSubcategories && !toggle.classList.contains('no-subcategories')) {
          const categoryDiv = toggle.closest('.faq-sidebar__category');
          if (!categoryDiv) {
            return;
          }
          
          const subcategories = categoryDiv.querySelector('[data-subcategories]');
          if (!subcategories) {
            return;
          }
          
          // Use a named function for easier debugging
          const handleToggleClick = function(e) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            
            // Simple toggle logic
            const isOpen = subcategories.classList.contains('is-open');
            
            if (isOpen) {
              // Close this category
              subcategories.classList.remove('is-open');
              toggle.classList.remove('is-active');
              toggle.setAttribute('aria-expanded', 'false');
            } else {
              // Close other open categories
              const otherCategories = sidebar.querySelectorAll('[data-subcategories].is-open');
              otherCategories.forEach(otherSub => {
                if (otherSub !== subcategories) {
                  otherSub.classList.remove('is-open');
                  const otherToggle = otherSub.closest('.faq-sidebar__category')?.querySelector('[data-category-toggle]');
                  if (otherToggle) {
                    otherToggle.classList.remove('is-active');
                    otherToggle.setAttribute('aria-expanded', 'false');
                  }
                }
              });
              
              // Open current category
              subcategories.classList.add('is-open');
              toggle.classList.add('is-active');
              toggle.setAttribute('aria-expanded', 'true');
              
              // Update category view and URL hash
              const categoryHandle = toggle.getAttribute('data-category-handle');
              if (categoryHandle) {
                window.location.hash = '#category-' + categoryHandle;
                // Update the view
                setTimeout(function() {
                  if (typeof updateCategoryView === 'function') {
                    updateCategoryView();
                  }
                }, 50);
              }
            }
            
            return false;
          };
          
          // Attach the event listener - use capture phase to ensure it fires first
          toggle.addEventListener('click', handleToggleClick, true);
        } else {
          // For categories without subcategories, still handle click for navigation
          toggle.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            const categoryHandle = toggle.getAttribute('data-category-handle');
            if (categoryHandle) {
              window.location.hash = '#category-' + categoryHandle;
              // Use setTimeout to ensure updateCategoryView is available
              setTimeout(function() {
                if (typeof updateCategoryView === 'function') {
                  updateCategoryView();
                }
              }, 50);
            }
          }, true);
        }
        
        // Mark as having listener
        toggle.dataset.listenerAttached = 'true';
      });

      // Open active category on load, or first category with subcategories if none is active
      const activeToggle = sidebar.querySelector('[data-category-toggle].is-active');
      if (activeToggle) {
        const activeCategoryDiv = activeToggle.closest('.faq-sidebar__category');
        const activeSubcategories = activeCategoryDiv ? activeCategoryDiv.querySelector('[data-subcategories]') : null;
        if (activeSubcategories) {
          activeSubcategories.classList.add('is-open');
          activeToggle.setAttribute('aria-expanded', 'true');
        }
      } else {
        // If no active category, open the first one with subcategories
        const firstToggle = sidebar.querySelector('[data-category-toggle][data-has-subcategories="true"]:not(.no-subcategories)');
        if (firstToggle) {
          const firstCategoryDiv = firstToggle.closest('.faq-sidebar__category');
          const firstSubcategories = firstCategoryDiv ? firstCategoryDiv.querySelector('[data-subcategories]') : null;
          if (firstSubcategories) {
            firstSubcategories.classList.add('is-open');
            firstToggle.classList.add('is-active');
            firstToggle.setAttribute('aria-expanded', 'true');
            
            // Update URL hash and view
            const categoryHandle = firstToggle.getAttribute('data-category-handle');
            if (categoryHandle && typeof updateCategoryView === 'function') {
              window.location.hash = '#category-' + categoryHandle;
              setTimeout(function() {
                updateCategoryView();
              }, 50);
            }
          }
        }
      }
      
      // Mark as initialized
      sidebar.dataset.initialized = 'true';
    });
  }

  function handleCategoryToggle(toggle, sidebar) {
    // Don't do anything if no subcategories
    const hasSubcategories = toggle.getAttribute('data-has-subcategories') === 'true';
    if (!hasSubcategories || toggle.classList.contains('no-subcategories')) {
      return;
    }
    
    const categoryDiv = toggle.closest('.faq-sidebar__category');
    const subcategories = categoryDiv ? categoryDiv.querySelector('[data-subcategories]') : null;
    
    if (!subcategories) {
      return;
    }
    
    // Check if currently open by checking the is-open class
    const isExpanded = subcategories.classList.contains('is-open');
    // Get handle from data attribute (set by Liquid)
    const categoryHandle = toggle.getAttribute('data-category-handle');
    
    if (isExpanded) {
      closeCategory(toggle);
    } else {
      // Close other open categories
      const otherToggles = sidebar.querySelectorAll('[data-category-toggle].is-active');
      otherToggles.forEach(otherToggle => {
        if (otherToggle !== toggle) {
          closeCategory(otherToggle);
        }
      });
      
      openCategory(toggle);
      
      // Navigate to category view
      if (categoryHandle) {
        window.location.hash = '#category-' + categoryHandle;
        
        // Update the view immediately (use setTimeout to ensure function is available)
        setTimeout(function() {
          if (typeof updateCategoryView === 'function') {
            updateCategoryView();
          }
        }, 50);
      }
    }
  }

  function openCategory(toggle) {
    const categoryDiv = toggle.closest('.faq-sidebar__category');
    const subcategories = categoryDiv ? categoryDiv.querySelector('[data-subcategories]') : null;
    
    if (subcategories) {
      toggle.setAttribute('aria-expanded', 'true');
      toggle.classList.add('is-active');
      subcategories.classList.add('is-open');
    }
  }

  function closeCategory(toggle) {
    const categoryDiv = toggle.closest('.faq-sidebar__category');
    const subcategories = categoryDiv ? categoryDiv.querySelector('[data-subcategories]') : null;
    
    if (subcategories) {
      toggle.setAttribute('aria-expanded', 'false');
      toggle.classList.remove('is-active');
      subcategories.classList.remove('is-open');
    }
  }

  // Initialize immediately and on multiple events
  function runInit() {
    initFAQSidebar();
  }

  // Run immediately if DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runInit);
  } else {
    runInit();
  }

  // Multiple fallbacks to ensure it runs
  setTimeout(runInit, 100);
  setTimeout(runInit, 300);
  setTimeout(runInit, 500);
  setTimeout(runInit, 1000);
  
  // Also on window load
  window.addEventListener('load', runInit);

  // Re-initialize when Shopify theme editor loads
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(event) {
      const section = event.detail.sectionId;
      const sidebar = document.querySelector(`[data-section-id="${section}"] [data-faq-sidebar]`);
      if (sidebar) {
        sidebar.dataset.initialized = 'false';
        setTimeout(function() {
          initFAQSidebar();
        }, 100);
      }
    });
    
    document.addEventListener('shopify:section:reorder', function() {
      document.querySelectorAll('[data-faq-sidebar]').forEach(function(sidebar) {
        sidebar.dataset.initialized = 'false';
      });
      setTimeout(runInit, 100);
    });
  }

  // Show/hide category sections based on hash
  function updateCategoryView() {
    const hash = window.location.hash;
    const allCategorySections = document.querySelectorAll('[data-category-section]');
    
    if (allCategorySections.length === 0) {
      return; // No category sections found
    }
    
    // Hide all category sections first
    allCategorySections.forEach(section => {
      section.style.display = 'none';
      section.classList.add('hidden');
    });
    
    if (hash && hash.includes('category-')) {
      const hashParts = hash.substring(1).split('-sub-');
      const categoryHandle = hashParts[0].replace('category-', '');
      const subcategoryHandle = hashParts.length > 1 ? hashParts[1] : null;
      
      // Show the target category section
      const targetCategorySection = document.getElementById(hashParts[0]);
      if (targetCategorySection) {
        targetCategorySection.style.display = 'block';
        targetCategorySection.style.setProperty('display', 'block', 'important');
        targetCategorySection.classList.remove('hidden');
        
        // Scroll to category or subcategory
        setTimeout(() => {
          if (subcategoryHandle) {
            const targetSubcategory = document.getElementById(hash.substring(1));
            if (targetSubcategory) {
              // Start smooth scroll
              targetSubcategory.scrollIntoView({ behavior: 'smooth', block: 'start' });
              
              // Add highlight class after a short delay to allow scroll to start
              setTimeout(() => {
                targetSubcategory.classList.add('is-highlighted');
                // Remove highlight after animation completes (600ms animation + buffer)
                setTimeout(() => {
                  targetSubcategory.classList.remove('is-highlighted');
                }, 3000);
              }, 200);
            }
          } else {
            targetCategorySection.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }, 100);
      }
    } else {
      // Show first category by default
      if (allCategorySections.length > 0) {
        const firstSection = allCategorySections[0];
        firstSection.style.display = 'block';
        firstSection.style.setProperty('display', 'block', 'important');
        firstSection.classList.remove('hidden');
      }
    }
  }

  // Handle hash changes for deep linking
  function handleHashChange() {
    updateCategoryView();
  }

  // Handle subcategory link clicks (scroll to section)
  function handleSubcategoryLinkClick(e) {
    const link = e.target.closest('[data-subcategory-link]');
    if (!link) return;
    
    e.preventDefault();
    const categoryHandle = link.getAttribute('data-category-handle');
    const subcategoryHandle = link.getAttribute('data-subcategory-handle');
    const targetId = `category-${categoryHandle}-sub-${subcategoryHandle}`;
    
    // Update URL hash
    window.location.hash = targetId;
    
    // Update view and scroll
    updateCategoryView();
  }

  // Expose for manual initialization if needed
  window.initFAQSidebar = initFAQSidebar;
  window.updateCategoryView = updateCategoryView;

  // Initialize subcategory link handlers
  function initSubcategoryLinks() {
    document.addEventListener('click', handleSubcategoryLinkClick);
    window.addEventListener('hashchange', handleHashChange);
    
    // Initialize category view on page load - call after a small delay to ensure DOM is ready
    setTimeout(function() {
      updateCategoryView();
    }, 100);
  }

  // Initialize on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initSubcategoryLinks();
      // Also call updateCategoryView directly after DOM is ready
      setTimeout(function() {
        updateCategoryView();
      }, 200);
    });
  } else {
    initSubcategoryLinks();
    // Call immediately if DOM is already ready
    setTimeout(function() {
      updateCategoryView();
    }, 100);
  }
  
  // Also initialize after a delay to ensure DOM is ready
  setTimeout(function() {
    initSubcategoryLinks();
    updateCategoryView();
  }, 500);

  // Handle "Show more" button clicks
  function handleShowMoreClick(e) {
    const button = e.target.closest('[data-show-more-btn]');
    if (!button) return;
    
    e.preventDefault();
    e.stopPropagation();
    
    const subcategoryHandle = button.getAttribute('data-subcategory-handle');
    const linksContainer = button.previousElementSibling;
    const hiddenLinks = linksContainer.querySelectorAll('.hidden-link');
    const showMoreText = button.querySelector('.show-more-text');
    const showLessText = button.querySelector('.show-less-text');
    
    if (hiddenLinks.length > 0 && hiddenLinks[0].classList.contains('hidden-link')) {
      // Show all links
      hiddenLinks.forEach(link => {
        link.classList.remove('hidden-link');
        link.classList.add('show-all');
      });
      showMoreText.style.display = 'none';
      showLessText.style.display = 'inline-flex';
    } else {
      // Hide links beyond first 5
      hiddenLinks.forEach(link => {
        link.classList.add('hidden-link');
        link.classList.remove('show-all');
      });
      showMoreText.style.display = 'inline-flex';
      showLessText.style.display = 'none';
      
      // Scroll button into view
      button.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  }

  // Initialize show more buttons
  function initShowMoreButtons() {
    document.addEventListener('click', handleShowMoreClick);
  }

  // Initialize on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initShowMoreButtons);
  } else {
    initShowMoreButtons();
  }
  
  // Also initialize after a delay
  setTimeout(initShowMoreButtons, 500);
})();

